import React from "react";
import DOMPurify from 'dompurify';

function Viewer({ html }) {
  return (
    <div className="ql-editor" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
  )
}
export default Viewer;